import React from 'react';

export default function RegistrationCompletePane(props) {

    return (
        <React.Fragment>

            <div style={{marginTop: "50px"}}>
                <div
                    style={{
                        paddingTop: "50px",
                        paddingBottom: "30px",
                        border: "solid 2px white",
                        borderRadius: "15px",
                        maxWidth: "800px",
                        margin: "auto"
                    }}
                >
                    <div
                        className={"default-font-huge default-font-bold"}
                    >
                        Registration Complete!
                    </div>
                    <div
                        style={{
                            margin: "30px"
                        }}
                    >
                        Please check your email for information about the event!
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}